export default __webpack_public_path__ + "static/review-2-e868273d378082bee1a2cb2efeda1965.png";